<template>
<div>
  <div v-if="debugMode">
    <p v-if="resultData.error">{{ resultData.error }}</p>
    <p v-if="resultData.shouldLoadData">Loading data... {{ resultData.loadingPercent }}%</p>
    <p v-else>Results complete {{ 'Unique: ' + uniqueAmazonProducts.length }}</p>
  </div>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3">
        <h2 class="h2">Products Found</h2>

        <div class="btn-toolbar mb-2 mb-md-0">
          <div class="btn-group me-2">
            <a :href="shareEmailLink" type="button" class="btn btn-sm btn-outline-secondary">
              Share
            </a>
            <a :href="this.backendHost + '/csv/' + this.crawlId" class="btn btn-sm btn-outline-secondary">
              Export CSV
            </a>
          </div>
          <!--
          <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
            <span data-feather="calendar"></span>
            This week
          </button>
          -->
        </div>
      </div>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
          <a href="#" @click.prevent="this.$router.push({name: 'pageResults'})">[ Switch to Pages Found ]</a>
      </div>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <h4 class="h4 text-truncate">
          <span v-for="link in resultData.initialLinks" :key="link" :title="link">
            <i class="bi-check-circle-fill pe-2"></i>{{ link }}
          </span>      
        </h4>
      </div>
      <div v-if="resultData.loadingPercent < 100" class="progress">
        <div class="progress-bar" role="progressbar" :style="'width:' + resultData.loadingPercent + '%;'" :aria-valuenow="resultData.loadingPercent" aria-valuemin="0" aria-valuemax="100">{{ resultData.loadingPercent }}%</div>
      </div>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 mb-3">
        <div class="input-group">
          <input class="form-control" type="text" v-on:keyup.enter="applyPageFilter" ref="filterInput" placeholder="Search by keyword" aria-label="Search by keyword">
          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="applyPageFilter">Search</button>
        </div>
      </div>

      <div class="d-flex flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="starFilter" value="starFilter" v-model="lowValueFilterChecked">
          <label class="form-check-label pe-0 me-0" for="starFilter">Star rating below</label>
        </div>
        <div class="form-check form-check-inline ms-0 ps-0">
          <select v-model="lowValueFilter" class="form-select form-select-sm" aria-label=".form-select-sm example">
            <option selected value="1">1 star</option>
            <option value="2">2 stars</option>
            <option value="3">3 stars</option>
            <option value="4">4 stars</option>
            <option value="5">5 stars</option>
          </select>
        </div>

        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="unavailable" value="unavailable" v-model="unavailableFilterChecked">
          <label class="form-check-label" for="inlineCheckbox2">Out of stock only</label>
        </div>
        <div class="input-group input-group-sm" style="max-width: 50%">
          <input v-on:keyup.enter="applyAffiliateFilter" ref="affiliateTagInput" type="text" class="form-control" placeholder="My affiliate tag" aria-label="My affiliate tag" aria-describedby="button-addon2">
          <button @click="applyAffiliateFilter" class="btn btn-outline-secondary" type="button" id="button-addon2">Check tag</button>
        </div>
      </div>

      <!-- Affiliate tag filter -->
      <div v-if="affiliateTagFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <h5 v-if="affiliateTagOk"><i class="bi-check-circle-fill pe-2"></i>All tags match:</h5>
        <h5 v-else><i class="bi-exclamation-triangle-fill pe-2"></i>Showing products with tag other than:</h5>
      </div>  
      <div v-if="affiliateTagFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
          <span>"{{ affiliateTagFilter }}" <a href="#" @click.prevent="clearAffiliateFilter"> <i class="bi-trash-fill px-1"></i>[ remove ]</a></span>
      </div>

      <!-- Star filter -->
      <div v-if="lowValueFilterChecked" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <h5>Showing products with rating lower than:</h5>
      </div>  
      <div v-if="lowValueFilterChecked" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
          <span>{{ this.lowValueFilter }} stars <a href="#" @click.prevent="lowValueFilterChecked=false"> <i class="bi-trash-fill px-1"></i>[ remove ]</a></span>
      </div>

      <!-- Unavailable filter -->
      <div v-if="unavailableFilterChecked" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <h5>Showing out of stock products:</h5>
      </div>  
      <div v-if="unavailableFilterChecked" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
          <span>Out of stock only <a href="#" @click.prevent="unavailableFilterChecked=false"> <i class="bi-trash-fill px-1"></i>[ remove ]</a></span>
      </div>

      <!-- Keyword filter -->
      <div v-if="pageFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <h5>Showing results with keywords:</h5>
      </div>  
      <div v-if="pageFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
          <span>"{{ this.pageFilter }}" <a href="#" @click.prevent="clearPageFilter"> <i class="bi-trash-fill px-1"></i>[ remove ]</a></span>
      </div>

      <!-- Page filter -->
      <div v-if="currentSelectedPageFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <h5>Showing products by specific page:</h5>
      </div>  
      <div v-if="currentSelectedPageFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
          <span>{{ this.currentSelectedPageFilter }} <a href="#" @click.prevent="currentSelectedPageFilter=null"> <i class="bi-trash-fill px-1"></i>[ remove ]</a></span>
      </div>  

  <div class="album bg-light">
        <div v-if="uniqueAmazonProducts && uniqueAmazonProducts.length > 0" class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
            <div class="col" v-for="(metadata, index) in uniqueAmazonProducts" :key="metadata.amazonMetadata.productPage">
              <product-card :metadata="metadata" :product-id="index"></product-card>
            </div>
        </div>
        <div v-else>
          <h2>No products found <span v-if="resultData.loadingPercent < 100">yet (scan running...)</span> <a v-if="isActiveFilter" class="btn btn-secondary" href="#" @click.prevent="clearAllFilters">Click here to clear all filters</a></h2>
        </div>
  </div>
</div>
</template>

<script>
import ProductCard from '../components/ProductCard.vue'

export default {
  components: {
    ProductCard
  },
  props: ['crawlId', 'selectedPageFilter', 'resultData'],
  data() {
    return {
      pageFilter: null,
      debugMode: false,
      currentSelectedPageFilter: this.selectedPageFilter,
      affiliateTagFilter: null,
      lowValueFilter: '3',
      lowValueFilterChecked: false,
      unavailableFilterChecked: false,
      affiliateTagOk: null
    };
  },
  methods: {
    filterUnavailableProducts(inputItems) {
      if (! this.unavailableFilterChecked) {
        return inputItems;
      }

      let unavailableItems = inputItems.filter(item => {
        if (item.amazonMetadata.trialLimitReached) {
          return false;
        }
        return ! item.amazonMetadata.productAvailable;
      });

      return unavailableItems;
    },
    filterLowRatingProducts(inputItems) {
      if (! this.lowValueFilterChecked) {
        return inputItems;
      }
      if (! this.lowValueFilter) {
        return inputItems;
      }

      let lowValueItems = inputItems.filter(item => {
          return item.amazonMetadata.productStars < this.lowValueFilter;
        });

      return lowValueItems;
    },
    sortItems(inputItems) {
      const sortedFilteredUniqueItems = inputItems.sort((firstEl, secondEl) => {
          const diff = firstEl.amazonMetadata.trialLimitReached - secondEl.amazonMetadata.trialLimitReached;
          if (diff !== 0) {
            return diff;
          }
          return ('' + firstEl.amazonMetadata.productTitle).localeCompare(secondEl.amazonMetadata.productTitle)
        });
        return sortedFilteredUniqueItems;
    },
    filterUniqueProducts(inputItems) {
      if (! inputItems) {
        return [];
      }
      const filteredUniqueItems = {};
      for (const amazonItem of inputItems) {
        for (const metadataItem of amazonItem.uniqueMetadataList) {
          if (this.pageFilter && ! ('' + metadataItem.amazonMetadata.productTitle).toLowerCase().includes(this.pageFilter)) {
            continue;
          }

          if (! filteredUniqueItems[metadataItem.amazonMetadata.productPage]) {
            filteredUniqueItems[metadataItem.amazonMetadata.productPage] = metadataItem;
          } else {
            //console.log("Found => " + metadataItem.amazonMetadata.productPage);
          }
        }
      }
      return Object.values(filteredUniqueItems);
    },
    filterItemsByKeyword(inputItems) {
      if (! this.pageFilter) {
        return inputItems;
      }
      let filteredItems = inputItems.filter(item => {
          const found = item.uniqueMetadataList.find(metadata => {
                            const result = ('' + metadata.amazonMetadata.productTitle).toLowerCase().includes(this.pageFilter)
                            return result;
                          });

          return found;
        });

      return filteredItems;
    },
    filterItemsByPage(inputItems) {
      if (! this.currentSelectedPageFilter) {
        return inputItems;
      }
      
      let filteredItems = inputItems.filter(item => {
            const found = item.uniqueMetadataList.find(metadata => {
                            const result = ('' + metadata.containingUrl) === this.currentSelectedPageFilter;
                            //console.log(result, metadata);
                            return result;
                          });

          return found;
      })
      return filteredItems;
    },
    filterItemsByAffiliateTagMismatch(inputItems) {
      if (! this.affiliateTagFilter) {
        return inputItems;
      }

      const matchingItems = [];
      for (const amazonItem of inputItems) {
        //console.log("Inspecting...", amazonItem.uniqueMetadataList)

        const foundItem = amazonItem.uniqueMetadataList.find(amazonMetadataLink => {
          if (amazonMetadataLink.amazonMetadata.trialLimitReached) {
            return false;
          }
          const result = ('' + amazonMetadataLink.amazonMetadata.affiliateTag) !== this.affiliateTagFilter
          //console.log(amazonMetadataLink, ('' + amazonMetadataLink.amazonMetadata.productPage), result)
          return result
        });

        if (foundItem) {
          matchingItems.push(amazonItem);
        }
      }

      this.affiliateTagOk = false;
      if (matchingItems.length == 0) {
        // All matched, just return products
        this.affiliateTagOk = true;
        return inputItems;
      }

      return matchingItems;
    },
    applyPageFilter() {
      this.pageFilter = this.$refs.filterInput.value.toLowerCase();
    },
    applyAffiliateFilter() {
      this.affiliateTagFilter=this.$refs.affiliateTagInput.value.toLowerCase();
    },
    clearPageFilter() {
      this.pageFilter = null;
      this.$refs.filterInput.value = '';
    },
    clearAffiliateFilter() {
      this.affiliateTagFilter = null;
      this.$refs.affiliateTagInput.value = '';
      this.affiliateTagOk = null;
    },
    clearAllFilters() {
      this.clearAffiliateFilter();
      this.clearPageFilter();
      this.currentSelectedPageFilter = null;
      this.lowValueFilterChecked = false;
      this.unavailableFilterChecked = false;
    }
  },
  computed: {
    isActiveFilter() {
      return this.pageFilter
        || this.currentSelectedPageFilter
        || this.affiliateTagFilter
        || this.lowValueFilterChecked
        || this.unavailableFilterChecked;
    },
    shareEmailLink() {
      const pageUrl = this.resultData.initialLinks && this.resultData.initialLinks[0];
      const subject = encodeURIComponent('PageCheckup.com results for: ' + pageUrl);
      const body = encodeURIComponent("Hi, I ran an affiliate link scan on my site and thought you would be interested in the result: http://www.pagecheckup.com/results/" + this.crawlId + '/pages');
      
      return "mailto:?subject="+subject+"&body="+body;
    },
    uniqueAmazonProducts() {
      if (! this.resultData.amazonItems) {
        return [];
      }

      let filteredItems = this.resultData.amazonItems;
      
      filteredItems = this.filterItemsByPage(filteredItems);
      filteredItems = this.filterItemsByKeyword(filteredItems);
      filteredItems = this.filterItemsByAffiliateTagMismatch(filteredItems);
      filteredItems = this.filterUniqueProducts(filteredItems);
      filteredItems = this.filterLowRatingProducts(filteredItems);
      filteredItems = this.filterUnavailableProducts(filteredItems);
      filteredItems = this.sortItems(filteredItems);
      
      return filteredItems;
      
    },
  }
};
</script>
